export const CUSTOMER_FEATURE_KEYS = {
  mspPitchBook: 'msp_pitch_book',
  developerIntegrations: 'developer_integrations',
  supplierPlus: 'supplier_plus',
  telelens: 'telelens',
} as const;

export type KnownCustomerFeatureKey =
  typeof CUSTOMER_FEATURE_KEYS[keyof typeof CUSTOMER_FEATURE_KEYS];

export type CustomerFeatureAudience = 'msp' | 'workspace' | 'vendor';

export type CustomerFeatureCatalogEntry = {
  audience: readonly CustomerFeatureAudience[];
  description: string;
  key: KnownCustomerFeatureKey;
  name: string;
  surfaces: string[];
};

export const CUSTOMER_FEATURE_CATALOG: readonly CustomerFeatureCatalogEntry[] = [
  {
    key: CUSTOMER_FEATURE_KEYS.mspPitchBook,
    name: 'MSP Pitch Book',
    description: 'Controls MSP access to the production-ready Pitch Book surface.',
    audience: ['msp'],
    surfaces: ['/pitch-book', 'msp_sidebar', 'msp_accounts'],
  },
  {
    key: CUSTOMER_FEATURE_KEYS.developerIntegrations,
    name: 'Developer Integrations',
    description: 'Controls workspace access to personal access tokens, supplier API docs, webhook configuration, and API execution.',
    audience: ['workspace'],
    surfaces: ['/settings?tab=integrations', '/docs', 'supplier-rest-api', 'developer-webhooks'],
  },
  {
    key: CUSTOMER_FEATURE_KEYS.telelens,
    name: 'TeleLens',
    description: 'Controls workspace access to TeleLens Supplier Security Briefing campaign creation, recipient uptake tracking, pricing, and supplier landing-page setup.',
    audience: ['workspace'],
    surfaces: ['/telelens', 'customer_sidebar', 'supplier-security-snapshot-campaigns'],
  },
  {
    key: CUSTOMER_FEATURE_KEYS.supplierPlus,
    name: 'SupplierPlus',
    description: 'Controls premium supplier-side insight, optimisation, visibility, and conversion surfaces for SupplierPlus.',
    audience: ['vendor'],
    surfaces: [
      '/vendor/dashboard',
      '/vendor/profile',
      '/vendor/questionnaires',
      '/vendor/visibility',
      '/upgrade/supplier-plus',
      'supplierplus-upsell',
    ],
  },
] as const;

export function getCustomerFeatureCatalogEntry(key: string) {
  return CUSTOMER_FEATURE_CATALOG.find((entry) => entry.key === key) ?? null;
}
